import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { configQuery } from '../../utils/config-query';
import { IHome, IHomeDetails } from '../../utils/interfaces/home';
import { IResponse } from '../../utils/interfaces/response';

@Injectable({
  providedIn: 'root',
})
export class HomeService {
  private readonly URI_API = environment.apiConfig.uri + 'Home';

  constructor(private readonly httpClient: HttpClient) {}

  getDataHome(
    search: boolean,
    searchString: string = '',
    page: number = 0,
    take: number = 0,
    status: boolean | null = null
  ): Observable<IResponse<IHome[]>> {
    const calcData = (date: Date) => {
      const today = new Date();
      const todayDate = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate()
      );

      const inputDate = new Date(date);
      const inputDateOnly = new Date(
        inputDate.getFullYear(),
        inputDate.getMonth(),
        inputDate.getDate()
      );
      const isSameDay = todayDate.getTime() === inputDateOnly.getTime();

      if (!isSameDay) {
        return false;
      }

      const timeDifference = Math.abs(today.getTime() - inputDate.getTime());

      return timeDifference <= 3600000;
    };

    return this.httpClient
      .get<IResponse<IHome[]>>(
        `${this.URI_API}${configQuery(
          search,
          searchString,
          page,
          take,
          status
        )}`
      )
      .pipe(
        map((res) => {
          return {
            ...res,
            data: res.data.map((i) => {
              return {
                ...i,
                id: i.deviceId,
                status: calcData(new Date(i.lastConnection)),
              };
            }),
          };
        })
      );
  }

  getDataHomeDetails(deviceId: string): Observable<IResponse<IHomeDetails>> {
    return this.httpClient
      .get<IResponse<IHomeDetails>>(`${this.URI_API}/${deviceId}`)
      .pipe(
        map((res) => {
          return {
            ...res,
            data: {
              ...res.data,
              emailList: res.data.emailList.map((i) => {
                return {
                  ...i,
                  day: i.emailFrequencyList.includes(1) ? 'Sim' : 'Não',
                  week: i.emailFrequencyList.includes(2) ? 'Sim' : 'Não',
                  month: i.emailFrequencyList.includes(3) ? 'Sim' : 'Não',
                };
              }),
            },
          };
        })
      );
  }
}
